import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SummaryIpo } from '../models/summary-ipo';
import { Page } from '../models/page';
import { SortData } from '../models/sort-data';
import { WrapperService } from '../utils/wrapper-service';
import { Dividend } from '../models/dividend';
import { Observable } from 'rxjs';
import { PagedData } from '../models/paged-data';
import { TransferState } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SummaryHomeService{
  pagedDataAny: any;
  urlSuffixPath="/summary";
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private transferHttp: TransferState, 
    private http: HttpClient) { }

    getInfoListByLang(lang: string) : any{
      let postUrl = `${environment.serviceApiUrl}${this.urlSuffixPath}/info-list?lang=${lang}`
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, null, () => {
        return this.http.get<any>(postUrl);
        })   
    }
    getAnalysisListByLang(lang: string, type:string) : any{
      let postUrl = `${environment.serviceApiUrl}${this.urlSuffixPath}/analysis-list?type=${type}&lang=${lang}`;
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, null, () => {
        return this.http.get<any>(postUrl);
        })   
    }
    getStockRecommendations(lang: string) {
      let postUrl = `${environment.serviceApiUrl}${this.urlSuffixPath}/recommendation-list?lang=${lang}`;
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, null, () => {
        return this.http.get<any>(postUrl);
        })   
    }
    getCapitalIncreases(lang: string) {
      let postUrl = `${environment.serviceApiUrl}${this.urlSuffixPath}/capital-increase-list?lang=${lang}`;
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, null, () => {
        return this.http.get<any>(postUrl);
        })   
    }
    getHeadlineListByLang(lang: string) : any{
      let postUrl = `${environment.serviceApiUrl}${this.urlSuffixPath}/headline-list?lang=${lang}`;
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, null, () => {
        return this.http.get<any>(postUrl);
        })   
    }
   
    getIpoListByType(lang: string,type: string) : Observable<SummaryIpo[]> {
      let postUrl = `${environment.serviceApiUrl}${this.urlSuffixPath}/ipo-list?lang=${lang}&type=${type}`
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, null, () => {
        return this.http.get<any>(postUrl);
        })   
    }   

    getMostIncreaseDividendStocks(lang: string,year: number) {
      let postUrl = `${environment.serviceApiUrl}${this.urlSuffixPath}/dividend-increase-yearly-list?year=${year}&lang=${lang}`;
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, null, () => {
        return this.http.get<any>(postUrl);
        })   
    }

    getPageAbleDividendList(page: Page, sortData: SortData<Dividend>): Observable<PagedData<Dividend>> {
      let postUrl = `${this.urlSuffixPath}` + "/pageable-list?page=" + (page.pageNumber + 1) + "&pageSize=" + page.size;
      return WrapperService.getData(this.transferHttp,this.platformId,postUrl, sortData, () => {
      return this.http.post(postUrl, sortData);
    })
    }
}
